import { createStore } from 'vuex';

import state from "@/store/state.js";

//modules
import AuthModule from '@/store/modules/AuthModule.js';


export default createStore({
  state,
  AuthModule
	// modules: {
	// 	AuthModule,
  // }
})
